<template>
  <div class="d-flex justify-center align-center flex-column full-height">
    <div >
      <img :src="notfoundIcon" alt="error icon">
    </div>
    <p class="required-page-not-found">{{ $t("overview.pageNotFound") }}</p>
    <p class="address-entered-incorrectly">{{ $t("overview.addressIncorrectly")}}</p>
    <div @click="goToMainPage">
      <auth-button class='back-main-page-block'>
        <span class="back-main-page"> {{ $t("overview.BackMainPage")}}</span>
      </auth-button>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/auth/components/AuthButton.vue'

export default {
  name: 'PageNotFoundComponent',

  components: { AuthButton },

  data() {
    return {
      notfoundIcon: require('@/assets/auth/notfound.png'),
    };
  },

  methods: {
    goToMainPage() {
      location.href = `${process.env.VUE_APP_BASE_LANDING_URL}`
    }
  },

};
</script>

<style scoped lang="scss">
.full-height {
  height: 100vh;
}

.required-page-not-found {
  color: var(--Main, #28334A);
  text-align: center;
  font-family: Gilroy, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 118%;
  margin-top: -16px;
}

.address-entered-incorrectly {
  color: var(--Main, #28334A);
  text-align: center;
  font-family: Gilroy, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  opacity: 0.4;
}

.back-main-page {
  color: var(--White, #FFF);
  font-family: Gilroy, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 112%;
}

.back-main-page-block{
  padding: 6px 40px!important;
  border-radius: 100px;
  height: 100% !important;
  margin-top: 30px!important;
}
</style>
